export default __webpack_public_path__ + "files/FP3_European_Structural_and_Investment_Funds.pdf";